import styled from 'styled-components';
import { setColor, setRem } from '../../utils/styles';
import { motion } from 'framer-motion';

export const Wrapper = styled(motion.div)`
  padding: 0 ${setRem(50)} ${setRem(50)};
  max-width: ${setRem(1024)};
  margin: 0 auto;
`;

export const PageTitle = styled.h1`
  padding: ${setRem(25)} 0;
  max-width: ${setRem(1024)};
  margin: 0 auto;
`;

export const TourGrid = styled.div`
  padding: ${setRem(25)} 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap: ${setRem(40)};

  a {
    display: block;
    border-radius: 1.25rem;
    overflow: hidden;

    img {
      width: 100%;
      height: auto;
      display: block;
    }

    div {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px;
      background-color: ${setColor.secondaryColor};
      position: relative;
      z-index: 2;

      &:before {
        content: '';
        display: block;
        position: absolute;
        top: -20%;
        left: -25%;
        width: 150%;
        height: 150%;
        background: ${setColor.secondaryColor};
        border-radius: 50%;
      }

      span {
        padding-bottom: 4px;
        font-weight: bold;
        z-index: 2;
      }
    }
  }
`;
